module.exports = __webpack_public_path__ + "static/media/Question2.4e8dd18b.svg";